import { createContext } from 'react';

/**
 * O painel de detalhe que esta em volta, quando ha um.
 *
 * Existe por uma regra so da R01 (p.29): "nunca empilhar duas modais". O
 * painel EXPANDIDO ja e uma janela (`aria-modal`); uma confirmacao ou uma
 * acao aberta de dentro dele virava modal sobre modal. A `Janela` pede ao
 * painel que reduza antes de abrir.
 *
 * `expandir` e o caminho inverso, e serve ao formulario MEDIO que mora no
 * painel: a ficha do equipamento tem dez campos em tres secoes, e em 360 px
 * sobravam ~120 px de area util entre o cabecalho, os dados-chave e o rodape
 * — apareciam "Codigo" e metade de "Descricao". A decisao 34 do dono criou o
 * "Expandir" exatamente para isso; o que faltava era o formulario pedi-lo ao
 * abrir, em vez de deixar a pessoa descobrir o botao.
 *
 * DESDE 31/10/2026 O PAINEL ABRE EXPANDIDO (pedido do dono), e o recuo da
 * janela passou a ser emprestado: `reduzir` devolve a funcao que traz o painel
 * de volta a forma que ele tinha, e a `Janela` a chama ao fechar. Sem isso,
 * toda confirmacao aberta do painel ("Desativar equipamento?") o deixava
 * estreito para sempre. O recuo emprestado nao grava a escolha da pessoa.
 */
export const ContextoDoPainel = createContext<
  { readonly reduzir: () => () => void; readonly expandir: () => void } | null
>(null);
